<div
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="dgSelectionModalTitle"
  aria-hidden="true"
  [class.show]="showModal"
  [ngStyle]="{ display: showModal ? 'block' : 'none' }"
>
  <div
    class="modal-dialog modal-dialog-scrollable"
    [ngClass]="'modal-' + modalSize"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ title }}
        </h5>
        <a
          *ngIf="!hideCancelButton"
          href="javascript:void(0)"
          class="close no-spinner"
          aria-label="Close"
          (click)="closeModal.emit()"
        >
          <i class="ifc-custom ifc-close" aria-hidden="true"></i
          ><span class="sr-only"></span>
        </a>
      </div>
      <div class="modal-body">
        <div id="modalContent">
          <ng-content></ng-content>
        </div>
      </div>
      <div class="modal-footer" *ngIf="!hideButtons">
        <ng-container *ngIf="layoutTranslations$ | async as layoutTranslations">
          <div class="row">
            <div class="col-6">
              <button
                *ngIf="!hideCancelButton"
                type="button"
                class="btn btn-block btn-iconed btn-iconed-default-white btn-iconed-left w-auto"
                (click)="closeModal.emit()"
              >
                {{
                  !!cancelButtonLabel
                    ? cancelButtonLabel
                    : layoutTranslations['ModalButtonClose']
                }}
                <i class="btn-icon ifc-custom ifc-close"></i>
              </button>
            </div>
            <div class="col-6">
              <button
                *ngIf="confirmButtonLabel"
                type="button"
                class="btn btn-block btn-iconed btn-iconed-primary w-auto float-right"
                (click)="confirm.emit()"
              >
                {{ confirmButtonLabel }}
                <i class="btn-icon ifc-custom ifc-arrow-right"></i>
              </button>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
